import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import XdpList from './containers/XdpList';
import XdpCreate from './containers/XdpCreate';
import XdpEdit from './containers/XdpEdit';
import XdpView from './containers/XdpView';
import { SYSTEM_CONFIGURATION_ROUTE, XDP, NETWORK } from '../../constants';

interface Props {
}

const Xdp: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XDP}`}>
        <XdpList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XDP}/create`}>
        <XdpCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XDP}/edit`}>
        <XdpEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XDP}/view`}>
        <XdpView />
      </Route>
    </Fragment>
  );
};

export default Xdp;
